import PokerChipCalculator from './PokerChipCalculator.vue';
import PokerChipCalcModule from './store';
import VueMq from 'vue-mq'
import mapValues from 'lodash/mapValues';

export default {
    install(Vue, { store, config = {} }) {
        Vue.component('poker-chip-calculator', PokerChipCalculator);

        store.registerModule('pokerChipCalcModule', PokerChipCalcModule);

        // Css classes
        let cssClasses =
            config.layout && config.layout.styles
                ? config.layout.styles
                : require('./assets/styles/default.scss');

        // Css breakpoints
        let cssBreakpoints = 
            config.layout && config.layout.breakpoints
            ? config.layout.breakpoints
            : require('./assets/styles/utils/breakpoints.scss');
        
        Vue.use(VueMq, { breakpoints: mapValues(cssBreakpoints, Number) });

        store.dispatch('pokerChipCalcModule/setCssClasses', cssClasses);

        // Laguage and currency
        if (config.language !== undefined && config.language) {
            store.dispatch('pokerChipCalcModule/setLanguage', config.language);
        }
        if (config.currency !== undefined && config.currency) {
            store.dispatch('pokerChipCalcModule/setCurrency', config.currency);
        }

        //Vue filter
        Vue.filter('withCommas', function (value) {
            return Number(value).toLocaleString();
        });

        Vue.filter('currencyString', function (value) {
            const language = config.language || store.state.pokerChipCalcModule.language;
            const currency = config.currency || store.state.pokerChipCalcModule.currency;
            return Number(value).toLocaleString(language, {
                style: 'currency',
                currency,
            });
        });

        // Translations
        if (config.translations !== undefined) {
            store.dispatch('pokerChipCalcModule/setTranslations', {
                translations: config.translations,
            });
        } else {
            store.dispatch('pokerChipCalcModule/setTranslations', {});
        }
    },
};
